// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-area {\r\n    width: 90%;\r\n    margin: 0 auto;\r\n    max-width: 1440px;\r\n}", ""]);
// Exports
module.exports = exports;
